import React from 'react';
import {
  Container,
  Paper,
  Typography,
  Box,
  Button,
} from '@mui/material';
import {
  Block,
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';
import EmailVerificationPrompt from './EmailVerificationPrompt';

interface RequireEmailVerificationProps {
  children: React.ReactNode;
}

const RequireEmailVerification: React.FC<RequireEmailVerificationProps> = ({ children }) => {
  const navigate = useNavigate();
  const user = useSelector((state: RootState) => state.auth.user);
  
  // Check if user needs email verification
  const needsEmailVerification = user && !user.is_active;

  if (needsEmailVerification) {
    return (
      <Container maxWidth="sm" sx={{ mt: 8 }}>
        <Paper elevation={3} sx={{ p: 4, textAlign: 'center' }}>
          <Block sx={{ fontSize: 60, color: 'warning.main', mb: 3 }} />
          
          <Typography variant="h4" sx={{ mb: 2, fontWeight: 600 }}>
            Email Verification Required
          </Typography>
          
          <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
            You must verify your email address before you can access this feature.
          </Typography>

          <EmailVerificationPrompt />

          <Box sx={{ mt: 4, display: 'flex', gap: 2, justifyContent: 'center' }}>
            <Button
              variant="outlined"
              onClick={() => navigate('/app/dashboard')}
            >
              Back to Dashboard
            </Button>
            <Button
              variant="contained"
              onClick={() => navigate('/app/profile')}
              sx={{
                background: 'linear-gradient(45deg, #3388ff 30%, #66a3ff 90%)',
                '&:hover': {
                  background: 'linear-gradient(45deg, #0066ff 30%, #3388ff 90%)',
                },
              }}
            >
              Go to Profile
            </Button>
          </Box>
        </Paper>
      </Container>
    );
  }

  // User is verified, render children
  return <>{children}</>;
};

export default RequireEmailVerification;